import { useMediaQuery } from '@chakra-ui/react';
import { breakpoints } from 'styles/theme';
import { Breakpoints } from 'types/breakpoints';

/**
 * Min-width for `useMediaQuery`, aligned with `styles/theme/breakpoints.ts` + Chakra `theme.breakpoints`.
 * `base` is Chakra’s default tier (0+) — not a key on the breakpoints map.
 */
const minWidthForBreakpoint = (breakpoint: Breakpoints): string => {
  if (breakpoint === Breakpoints.MOBILE) {
    return '0px';
  }
  const value = breakpoints[breakpoint as keyof typeof breakpoints];
  if (!value) {
    throw new Error(`Breakpoint ${breakpoint} not found`);
  }
  return value;
};

/**
 * `true` when viewport is at least this Chakra breakpoint (`min-width`).
 */
export const useBreakpoint = (breakpoint: Breakpoints): boolean => {
  return useMediaQuery([`(min-width: ${minWidthForBreakpoint(breakpoint)})`])[0];
};
